import { useStateContext } from "context/StateContext"
import uiux from 'assets/gifs/u.gif'
import frontend from 'assets/gifs/web-developement.gif'
import responsive from 'assets/gifs/responsive.gif'
import mobile from 'assets/gifs/mobile.gif'
import webDev from 'assets/gifs/frontend.gif'
import consult from 'assets/gifs/consult.gif'
import { Helmet } from "react-helmet-async"


export default function Services() {
    const { darkMode } = useStateContext()

    return (
        <>
            <Helmet>
                {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
                <meta charSet="utf-8" />
                <title> ستيفن اريك | خدمات </title>
            </Helmet>
            <div className='container' id="services-section-right-to-left" data-aos="fade-right">
                <div className="row py-4 ">
                    <div className="col text-style position-relative d-flex justify-content-center">
                        <h1 className={`${darkMode ? "text-body" : "text-body-tertiary"} fw-bold `}>خدمات</h1>
                        <h4 className='position-absolute align-self-center '>ما أفعله؟</h4>
                    </div>
                </div>

                {/* services */}
                <div className="row gx-4 gx-md-3 gx-xl-4 gy-5 row-cols-1 row-cols-sm-2 row-cols-xl-3 px-0 px-md-3 px-lg-5 mt-1 mb-5">
                    <div className="col">
                        <div className="card py-4 px-3 shadow">
                            <div className={`rounded-circle  p-1 bg-body`} style={{ boxShadow: `${darkMode ? "0 10px 20px rgba(255,255,255,0.09)" : "0 10px 20px rgba(0,0,0,0.1)"}` }}>
                                <img src={uiux} className="w-100" alt="" />
                            </div>
                            <h5 className="text-info mb-3 mt-4">تصميم واجهة المستخدم/تجربة المستخدم</h5>
                            <p className="text-body-secondary">شكراً جزيلاً. غالبًا ما يتم الحصول على نتيجة هذه الإطراءات، والتي يتم عقد الخيار بأكمله، خطأ المتاعب نفسها. الأهم من ذلك كله هو خيار الكراهية.</p>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card py-4 px-3 shadow">
                            <div className={`rounded-circle  p-2 bg-body`} style={{ boxShadow: `${darkMode ? "0 10px 20px rgba(255,255,255,0.09)" : "0 10px 20px rgba(0,0,0,0.1)"}` }}>
                                <img src={webDev} className="w-100" alt="" />
                            </div>
                            <h5 className="text-info mb-3 mt-4">تطوير الويب</h5>
                            <p className="text-body-secondary">شكراً جزيلاً. غالبًا ما يتم الحصول على نتيجة هذه الإطراءات، والتي يتم عقد الخيار بأكمله، خطأ المتاعب نفسها. الأهم من ذلك كله هو خيار الكراهية.</p>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card py-4 px-3 shadow">
                            <div className={`rounded-circle  p-1 bg-body`} style={{ boxShadow: `${darkMode ? "0 10px 20px rgba(255,255,255,0.09)" : "0 10px 20px rgba(0,0,0,0.1)"}` }}>
                                <img src={responsive} className="w-100" alt="" />
                            </div>
                            <h5 className="text-info mb-3 mt-4">الرسم المتجاوب</h5>
                            <p className="text-body-secondary">شكراً جزيلاً. غالبًا ما يتم الحصول على نتيجة هذه الإطراءات، والتي يتم عقد الخيار بأكمله، خطأ المتاعب نفسها. الأهم من ذلك كله هو خيار الكراهية.</p>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card py-4 px-3 shadow">
                            <div className={`rounded-circle  p-2 bg-body`} style={{ boxShadow: `${darkMode ? "0 10px 20px rgba(255,255,255,0.09)" : "0 10px 20px rgba(0,0,0,0.1)"}` }}>
                                <img src={mobile} className="w-100" alt="" />
                            </div>
                            <h5 className="text-info mb-3 mt-4">تطوير تطبيقات الهاتف المحمول</h5>
                            <p className="text-body-secondary">شكراً جزيلاً. غالبًا ما يتم الحصول على نتيجة هذه الإطراءات، والتي يتم عقد الخيار بأكمله، خطأ المتاعب نفسها. الأهم من ذلك كله هو خيار الكراهية.</p>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card py-4 px-3 shadow">
                            <div className={`rounded-circle  p-1 bg-body`} style={{ boxShadow: `${darkMode ? "0 10px 20px rgba(255,255,255,0.09)" : "0 10px 20px rgba(0,0,0,0.1)"}` }}>
                                <img src={frontend} className="w-100" alt="" />
                            </div>
                            <h5 className="text-info mb-3 mt-4">تطوير الواجهة الأمامية</h5>
                            <p className="text-body-secondary">شكراً جزيلاً. غالبًا ما يتم الحصول على نتيجة هذه الإطراءات، والتي يتم عقد الخيار بأكمله، خطأ المتاعب نفسها. الأهم من ذلك كله هو خيار الكراهية.</p>
                        </div>
                    </div>
                    <div className="col">
                        <div className="card py-4 px-3 shadow">
                            <div className={`rounded-circle  p-0 bg-body`} style={{ boxShadow: `${darkMode ? "0 10px 20px rgba(255,255,255,0.09)" : "0 10px 20px rgba(0,0,0,0.1)"}` }}>
                                <img src={consult} className="w-100" alt="" />
                            </div>
                            <h5 className="text-info mb-3 mt-4">الاستشارة والتعاون</h5>
                            <p className="text-body-secondary">شكراً جزيلاً. غالبًا ما يتم الحصول على نتيجة هذه الإطراءات، والتي يتم عقد الخيار بأكمله، خطأ المتاعب نفسها. الأهم من ذلك كله هو خيار الكراهية.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
